import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/qrCode";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import EventSaveTemplateWidget from "../../../../components/Apps/QRCode/Template/EventSaveTemplateWidget";
import GetDiscountTemplateWidget from "../../../../components/Apps/QRCode/Template/GetDiscountTemplateWidget";
import SaveMyContactTemplateWidget from "../../../../components/Apps/QRCode/Template/SaveMyContactTemplateWidget";
import RateOnTripadvisorTemplateWidget from "../../../../components/Apps/QRCode/Template/RateOnTripadvisorTemplateWidget";
import ViewPdfTemplateWidget from "../../../../components/Apps/QRCode/Template/ViewPdfTemplateWidget";
import RateOnFacebookTemplateWidget from "../../../../components/Apps/QRCode/Template/RateOnFacebookTemplateWidget";

//Import Tabs
import GenerateTab from "../../../../components/Apps/QRCode/GenerateTab";
import InfoTab from "../../../../components/Apps/QRCode/InfoTab";
import FrameTab from "../../../../components/Apps/QRCode/FrameTab";
import StyleTab from "../../../../components/Apps/QRCode/StyleTab";

export default function EditQRCode() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Generate");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled QR Code");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);

    const [qrCodeTabData, setQRCodeTabData] = useState({
        is_website_frontend: "",  
        generate_type: "URL",     
        generate_url: "https://dashboard.upgadeify.com",  
        generate_location: "",   
        title: "",   
        call_to_action_text: "",   
        caption: "",   
        frame_type: "",   
        qr_code_size: 200,   
        title_color: "",     
        foreground_color: "",     
        background_color: "",     
        frame_color: "",     
        caption_color: "",     
        title_font_size: "20px",     
        call_to_action_font_size: "15px",     
        caption_font_size: "13px",     
        custom_css: "",   
        custom_js: "",   
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateQRCodeTabData = (key, value) => {
        setQRCodeTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Generate", icon: "generate.png", label: "Generate" },
        { key: "Info", icon: "info.png", label: "Info" },
        { key: "Frame", icon: "frame.png", label: "Frame" },
        { key: "Style", icon: "style.png", label: "Style" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setQRCodeTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setQRCodeTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(qrCodeTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/qr-code');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/qr-code/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Generate" && (
                        <GenerateTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeSection === "Info" && (
                        <InfoTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeSection === "Frame" && (
                        <FrameTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/qr-code"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/qr-code/qr-code.svg`} alt="qr-code"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/qr-code/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/qr-code" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">QR Code <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Event_Save_Temp" && (
                      <EventSaveTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Get_Discount_Temp" && (
                      <GetDiscountTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Save_My_Contact_Temp" && (
                      <SaveMyContactTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Rate_On_Tripadvisor_Temp" && (
                      <RateOnTripadvisorTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "View_Pdf_Temp" && (
                      <ViewPdfTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Rate_On_Facebook_Temp" && (
                      <RateOnFacebookTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 